import { copies } from '@reveni-io/reveni-ui'

import { copiesKeyMap } from './constants'

export const getErrorDialogTitle = (fullKey, customCopies, lang) => {
  const customTitle = customCopies?.[lang]?.[fullKey]?.title

  if (customTitle) return customTitle

  return copies[lang]?.errors?.[copiesKeyMap[fullKey]]?.title || ''
}

export const getErrorDialogMessage = (fullKey, customCopies, lang, merchant) => {
  const customMessage = customCopies?.[lang]?.[fullKey]?.message

  if (customMessage) return customMessage

  return copies[lang]?.errors?.[copiesKeyMap[fullKey]]?.plainText(merchant) || ''
}
